export var useIsFollowUp = function (noteType) {
    var _a;
    return (_a = noteType === null || noteType === void 0 ? void 0 : noteType.includes('FollowUp')) !== null && _a !== void 0 ? _a : false;
};
